import React from 'react';
import AddIcon from './Icons/AddIcon';

export const AddButton = ({ onClick, ariaLabel = 'Add new time range' }) => {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className="flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out transform hover:scale-105 hover:bg-blue-100 hover:shadow-md"
    >
      <AddIcon />
    </button>
  );
};

export default AddButton;
